import { Box, Button, Typography } from "@mui/joy";
import Add from "@mui/icons-material/Add";
import React, { useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import GenericTableView from "../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import {
  GenericTableColumTypes,
  GenericTableFilterTypes,
} from "../../enum/TableView";
import { MenuItem } from "primereact/menuitem";
import { GenericTableColumns } from "../../models/GenericTableViewModel";
import { removeClient } from "../../service/clientService";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { v4 as uuid } from 'uuid';
import { RouteComponentProps } from "../../models/RouteComponent";
import { templateRemove } from "../../service/templateService";
import InductionAdd from "./Induction-Add";
import { removeInductionSlide } from "../../service/inductionService";

export default function InductionTable(props: RouteComponentProps) {
  const [selectedRecord, setSelectedRecord] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const toast = useRef(null as any);
  const dialog = useRef(null as any);

  const baseFilter = {
    title: { value: "", matchMode: FilterMatchMode.CONTAINS },
  };

  const addButton = (row: any) => {
    console.log("addButton row == ", row);
    setSelectedRecord(null);
    setVisible(true);
  };

  const itemSelected = (row: any) => {
    console.log("itemSelected row == ", row);
    setSelectedRecord(row.value);
    editConfirm(row);
  };

  const contextItemSelected = (row: any) => {
    console.log("contextItemSelected row == ", row);
    setSelectedRecord(row.value);
  };

  const acceptFunc = async () => {
    props.setGlobalLoader(true);
    const industry = await removeInductionSlide(selectedRecord.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({
      severity: "success",
      summary: "Induction Deleted Successfully",
      life: 3000,
    });
  };

  const editConfirm = (row: any) => {
    setVisible(true);
  };

  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: "Are you sure you want to proceed?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => acceptFunc(),
    });
  };

  const contextItems = () => {
    let objArray = [
      { label: "Edit", icon: "pi pi-fw pi-pencil", command: editConfirm },
    ];
    objArray.push({
      label: "Delete",
      icon: "pi pi-fw pi-trash",
      command: deleteConfirm,
    });
    return objArray;
  };

  const columns: GenericTableColumns[] = [
    {
      field: "photo",
      header: "Image",
      type: GenericTableColumTypes.Image,
      visible: true,
      sort: false,
      filter: false,
      filterOption: {
          type: GenericTableFilterTypes.Text,
          options: [
              {
                  label: "",
                  value: ""
              }
          ]
      }
  },
    {
      field: "title",
      header: "Title",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
          type: GenericTableFilterTypes.Text,
          options: [
              {
                  label: "",
                  value: ""
              }
          ]
      }
  },
  {
    field: "industry_list",
    header: "Industry",
    type: GenericTableColumTypes.Text,
    visible: true,
    sort: true,
    filter: true,
    filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
            {
                label: "",
                value: ""
            }
        ]
    }
},
{
  field: "job_task_list",
  header: "Job Task",
  type: GenericTableColumTypes.Text,
  visible: true,
  sort: true,
  filter: true,
  filterOption: {
      type: GenericTableFilterTypes.Text,
      options: [
          {
              label: "",
              value: ""
          }
      ]
  }
},
    {
      field: "created_at",
      header: "Created At",
      type: GenericTableColumTypes.Date,
      visible: true,
      sort: true,
      filter: false,
    },
  ];

  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          mb: 1,
          gap: 1,
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "start", sm: "center" },
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        <Typography level="h2" component="h1">
          Induction Slides
        </Typography>

        {/* <Button
            color="primary"
            startDecorator={<Add />}
            size="sm"
            onClick={() => setVisible(true)}
          >Add</Button> */}
      </Box>

      <GenericTableView
        reload={reload}
        baseFilters={baseFilter}
        url="induction-page"
        columns={columns}
        contextItems={contextItems}
        addButton={addButton}
        itemSelect={itemSelected}
        contextItemSelected={contextItemSelected}
      />

      <Dialog
        ref={dialog}
        header={selectedRecord?.id ? "Update Induction" : "Add Induction"}
        visible={visible}
        style={{ width: "50vw" }}
        onHide={() => setVisible(false)}
      >
        <InductionAdd
          setGlobalLoading={props.setGlobalLoader}
          setReload={setReload}
          reload={reload}
          record={selectedRecord}
          setVisible={setVisible}
          toast={toast}
          uuid={uuid()}
        />
      </Dialog>

      <ConfirmDialog />

      <Toast ref={toast} />
    </React.Fragment>
  );
}
